<div class="row">
  <div class="col-md">
    <h2 class="pb-s">
      Vorteile & Ansprechpartner
    </h2>

    <p>
      Wir freuen uns, dass Sie Teil des Beauftragtenprogramms sind oder werden möchten!    </p>
    <p>
      Als Beauftragte*r:
    </p>
    <ul>
      <li>haben Sie Zugang zu <strong>exklusiven Informationen</strong></li>
      <li>erhalten Sie <strong>Insights zu spannenden Fachthemen</strong>, die Ihnen helfen, den <strong>stressigen Apothekenalltag zu meistern</strong></li>
      <li>bieten wir Unterstützung, um <strong>Ihre Prozesse zu optimieren</strong></li>
      <li>schaffen Sie es, mit gezielten <strong>Tipps zur Endkundenaktivierung</strong> und unseren <strong>Kundenbindungsinstrumenten</strong>, Ihre <strong>Umsätze</strong> langfristig zu <strong>steigern</strong>, Ihre <strong>Apotheke zum Erfolg führen</strong> und gleichzeitig Ihre <strong>Kunden zu begeistern</strong></li>
      <li>steht auch der <strong>Spaß</strong> nicht an letzter Stelle, denn mit unseren <strong>Xperiences</strong> bringen wir mehrmals jährlich großartige <strong>Gewinnspiele</strong> für Sie und Ihr Team in die Apotheke</li>
    </ul>
    <p>
      Gemeinsam mit Ihnen freuen wir uns auf den Austausch und darauf, die Kooperation mit Leben zu füllen!
    </p>
    <p>
      Es grüßt Sie herzlich
    </p>
    <p>
      Ihr Beauftragten-Team
    </p>
  </div>
  <div class="col-md-3">
    <img src="../../assets/dummy/Allgemeines_Ansprechpartner_image.png"
         alt="Allgemeines Ansprechpartner Bild">
  </div>
</div>
<div class="row mt-xxl">
  <div class="col-md-12">
    <h2 class="pb-s">Ansprechpartner bei Rückfragen</h2>
  </div>
</div>
<div class="row">
  <div class="col-xl-6 mb-s">
    <div class="media">
      <img
          src="../../assets/dummy/2023_PKP_beauftragtenprogramm_AP_roger_werner_web.jpg"
          alt="Roger Werner" class="mr-3" width=128>
      <div class="media-body">
        <strong class="mb-s d-block">Roger Werner</strong>
        0 621 850 5 - 445<br>
        <a >kooperation@phoenixgroup.eu</a>
      </div>
    </div>
  </div>
</div>

